<template>
  <div class="layout-footer">
    <img :src="logoUrl" :alt="companyName" height="20" class="mr-2" />
    <span class="font-medium ml-2">{{ companyName }}</span>
  </div>
</template>

<script setup>
import { useLayout } from '@/layout/composables/layout';
import { useCompanyBrand } from '@/composables/useCompanyBrand';
import { computed } from 'vue';

const { layoutConfig } = useLayout();
const { companyName, companyLogoUrl } = useCompanyBrand();

const logoUrl = computed(() => {
  if (companyLogoUrl.value) return companyLogoUrl.value;
  return `/layout/images/${layoutConfig.darkTheme.value ? 'logo-white' : 'logo-dark'}.svg`;
});
</script>
<style lang="scss" scoped></style>
